import { Button, Form, Input, InputNumber, Select } from 'antd'
import { memo, useCallback } from 'react'
import { TrainingField } from 'types/fields'

type Props = {
    item: TrainingField
    onSubmit: (item: TrainingField) => void
    loading: boolean
}

export const TrainingFieldForm = memo((props: Props) => {
    const { item, onSubmit, loading } = props

    const onFinish = useCallback(
        (values: TrainingField) => {
            onSubmit(values)
        },
        [onSubmit]
    )

    return (
        <Form
            name='basic'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete='off'
            disabled={loading}
        >
            <Form.Item
                initialValue={item.name}
                label='Name'
                name='name'
                rules={[{ required: true, message: 'Please input position name!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                initialValue={item.dressingRoom}
                label='Dressing room'
                name='dressingRoom'
                rules={[{ required: true, message: 'Please select one option!' }]}
            >
                <Select>
                    <Select.Option key={'yes'} value={1}>
                        Yes
                    </Select.Option>
                    <Select.Option key={'no'} value={0}>
                        No
                    </Select.Option>
                </Select>
            </Form.Item>
            <Form.Item
                initialValue={item.shower}
                label='Shower'
                name='shower'
                rules={[{ required: true, message: 'Please select one option!' }]}
            >
                <Select>
                    <Select.Option key={'yes'} value={1}>
                        Yes
                    </Select.Option>
                    <Select.Option key={'no'} value={0}>
                        No
                    </Select.Option>
                </Select>
            </Form.Item>
            <Form.Item
                initialValue={item.camera}
                label='Camera'
                name='camera'
                rules={[{ required: true, message: 'Please select one option!' }]}
            >
                <Select>
                    <Select.Option key={'yes'} value={1}>
                        Yes
                    </Select.Option>
                    <Select.Option key={'no'} value={0}>
                        No
                    </Select.Option>
                </Select>
            </Form.Item>
            <Form.Item
                initialValue={item.price}
                label='Price'
                name='price'
                rules={[{ required: true, message: 'Please input price value!' }]}
            >
                <InputNumber />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
                <Button htmlType={'reset'}>Reset</Button>
            </Form.Item>
        </Form>
    )
})
